export default __webpack_public_path__ + "static/media/Wireless.19d8ca1a.png";